import * as Sentry from '@sentry/react'

/*
 * FAILED my-api CALL → Sentry (Duncan order CMT-2026-09-11-004, dispatch
 * 2026-10-28). Called from myApi.ts check() on every non-2xx.
 *
 * WHAT IS SENT: a SAVE / SUBMIT (method ≠ GET) failure, or any 5xx (GET
 * included — GET 4xx are noise). One warning message
 *   "<label> <status> <code>[ field=<field>]"
 * fingerprint ['my-fe-api-error', label, status, code, field] and tags only
 * (label / status / code / field). NO url, query, body, ids or values: label
 * is the call site's fixed name ('profile save'), code and field are only
 * sent when they look like a machine code / field name.
 *
 * VOLUME: at most ONE event per label + status + code per page load (on top
 * of Sentry's own dedupe). Never throws — telemetry must not break a save.
 */

const CODE = /^[a-z][a-z0-9_]{0,63}$/
const FIELD = /^[A-Za-z][A-Za-z0-9_.]{0,63}$/

const sent = new Set<string>()

export interface ApiFailure {
  label: string
  method: string
  status: number
  code?: unknown
  field?: unknown
}

/** The event for a failure, or null when it is not captured. Pure. */
export function apiFailureEvent(f: ApiFailure): {
  message: string
  fingerprint: string[]
  tags: Record<string, string>
} | null {
  const isGet = f.method.toUpperCase() === 'GET'
  if (isGet && f.status < 500) return null
  const code = typeof f.code === 'string' && CODE.test(f.code) ? f.code : 'unknown'
  const field = typeof f.field === 'string' && FIELD.test(f.field) ? f.field : ''
  const status = String(f.status)
  return {
    message: `${f.label} ${status} ${code}${field ? ` field=${field}` : ''}`,
    fingerprint: ['my-fe-api-error', f.label, status, code, field],
    tags: { label: f.label, status, code, field: field || '-' },
  }
}

export function captureApiFailure(f: ApiFailure): void {
  try {
    const ev = apiFailureEvent(f)
    if (!ev) return
    const key = `${f.label}|${ev.tags.status}|${ev.tags.code}`
    if (sent.has(key)) return
    sent.add(key)
    Sentry.captureMessage(ev.message, { level: 'warning', fingerprint: ev.fingerprint, tags: ev.tags })
  } catch {
    /* telemetry must never break the caller */
  }
}

/** Test-only reset of the per-page-load guard. */
export function __resetApiFailureCaptureForTests(): void {
  sent.clear()
}
